import { call, put, takeLatest } from 'redux-saga/effects';

import { addInspection, deleteInspection, searchInspection } from '../../services/API';
import {
  actionTypes,
  addRequestFailure,
  addRequestSuccess,
  deleteRequestFailure,
  deleteRequestSuccess,
  searchRequestFailure,
  searchRequestSuccess,
} from './actions';

function* getData(action) {
  const response = yield call(searchInspection, action.payload);
  yield put(
    response.isOk ? searchRequestSuccess(response.data) : searchRequestFailure(response.error),
  );
}

function* addData(action) {
  const response = yield call(addInspection, action.payload);
  yield put(
    response.isOk
      ? addRequestSuccess({ ...action.payload, added: true })
      : addRequestFailure(response.error, action.payload),
  );
}

function* deleteData(action) {
  const response = yield call(deleteInspection, action.payload);
  yield put(
    response.isOk
      ? deleteRequestSuccess({ ...action.payload, added: false })
      : deleteRequestFailure(response.error, action.payload),
  );
}

export default function* searchInspectionSaga() {
  yield takeLatest(actionTypes.SEARCH_REQUEST_START, getData);
  yield takeLatest(actionTypes.ADD_REQUEST_START, addData);
  yield takeLatest(actionTypes.DELETE_REQUEST_START, deleteData);
}
